import React, { useEffect, useRef, useState } from 'react';
import { Info } from 'lucide-react';

// Small "i" button that reveals a short explanation on click.
export default function InfoTip({ children, label = 'Xem giải thích', align = 'left' }) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        if (!open) return undefined;
        const close = event => { if (ref.current && !ref.current.contains(event.target)) setOpen(false); };
        const onKey = event => { if (event.key === 'Escape') setOpen(false); };
        document.addEventListener('mousedown', close);
        document.addEventListener('keydown', onKey);
        return () => { document.removeEventListener('mousedown', close); document.removeEventListener('keydown', onKey); };
    }, [open]);

    return (
        <span className="nas-info" ref={ref}>
            <button type="button" className={`nas-info-btn ${open ? 'is-open' : ''}`} aria-label={label} aria-expanded={open} onClick={event => { event.stopPropagation(); setOpen(value => !value); }}>
                <Info size={13} />
            </button>
            {open && <span className={`nas-info-pop is-${align}`} role="note">{children}</span>}
        </span>
    );
}
